import { NextSeo } from 'next-seo';
import * as React from 'react';
import Balancer from 'react-wrap-balancer';

import Layout from '@/components/layout/Layout';
import PriceCardContents from '@/components/pricing/PriceCardContents';
import PriceCardWrapper from '@/components/pricing/PriceCardWrapper';

const PricingPage: React.FC = () => {
  return (
    <>
      <NextSeo title='Pricing' />
      <Layout className='mt-12'>
        <div className='mb-10'>
          <h1 className='mb-3 text-center text-5xl'>Pricing</h1>
          <p className='text-center text-xl'>
            <Balancer>
              We charge based on the number of minutes of video you upload to
              the platform.
            </Balancer>
          </p>
        </div>
        <div className='flex flex-col justify-center gap-5 px-5 md:flex-row'>
          <PriceCardWrapper cta='Try free!' href='https://app.clip.fm/login'>
            <PriceCardContents
              price={0}
              planName='Free'
              features={[
                '60 upload minutes',
                'Auto captions',
                'Upload from YouTube',
              ]}
            />
          </PriceCardWrapper>
          <PriceCardWrapper cta='Get started' href='https://app.clip.fm/login'>
            <PriceCardContents
              price={49}
              planName='Hobbyist'
              features={[
                '300 upload minutes',
                'Auto captions',
                'Upload from YouTube',
              ]}
            />
          </PriceCardWrapper>
          <PriceCardWrapper
            cta='Get started'
            href='https://app.clip.fm/login'
            highlight
          >
            <PriceCardContents
              price={99}
              planName='Pro'
              features={[
                '600 upload minutes',
                'Auto captions',
                'Upload from YouTube',
              ]}
            />
          </PriceCardWrapper>
          <PriceCardWrapper cta='Book demo' href='https://app.clip.fm/login'>
            <p className='text-center text-4xl font-bold'>Custom</p>
            <p className='text-xl leading-9'>
              We offer custom solutions for teams and organizations. Get in
              touch or book a demo with us to learn more.
            </p>
          </PriceCardWrapper>
        </div>
      </Layout>
    </>
  );
};

export default PricingPage;
